import { FC, ReactNode } from 'react';
import NewOrderPaymentSkeleton from '@/features/orders/components/NewOrder/NewOrderPayment/NewOrderPaymentSkeleton';
import { cn } from '@/lib/utils';

type Props = {
	title: string | ReactNode;
	subtitle: string;
	isActive: boolean;
	onClick: () => void;
	icon: FC<{ className?: string }>;
	iconBgClassName: string;
	iconClassName: string;
	isLoading?: boolean;
	isError?: boolean;
	isMobile?: boolean;
};

const NewOrderPaymentOption: FC<Props> = ({
	title,
	subtitle,
	isActive,
	onClick,
	icon: Icon,
	iconBgClassName,
	iconClassName,
	isLoading = false,
	isError = false,
	isMobile,
}) => (
	<div
		className={cn(
			`p-6 flex flex-col gap-6 rounded-2.5xl bg-popover-10 cursor-pointer select-none outline ${
				isActive && !isLoading
					? 'outline-2 outline-primary-color-1000'
					: 'outline-1 outline-primary-color-100'
			} transition-all ease-out duration-75 hover:shadow-custom`,
			isMobile && 'p-4 gap-4'
		)}
		onClick={!(isLoading || isError) ? onClick : undefined}>
		{isLoading || isError ? (
			<NewOrderPaymentSkeleton />
		) : (
			<div className='flex items-center gap-4'>
				<div
					className={`size-8 flex items-center justify-center rounded-semi-xl ${iconBgClassName}`}>
					<Icon className={iconClassName} />
				</div>
				<div className='flex flex-col'>
					<h4 className='text-base font-medium'>{title}</h4>
					<p className='text-sm text-popover-600'>{subtitle}</p>
				</div>
				<div
					className={`size-4 ml-auto border-popover-1000 rounded-full ${
						isActive ? 'border-4' : 'border'
					}`}
				/>
			</div>
		)}
	</div>
);

export default NewOrderPaymentOption;
